import MainBlockLayout from '../../components/MainBlockLayout';
import { Row, Col, Nav, Tab, Button, Alert, Card, ListGroup } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import "react-image-gallery/styles/css/image-gallery.css";
import React, { useState } from "react";
import { SATELLITE_GALLERY_YEARS } from '../../data/satteliteImagesData';
import { generateImageTabs } from "../../utils/common";
import NewsLetterAccordion from './components/NewsLetterAccordion';
import { useSelector } from 'react-redux';
import SchoolStatistics from './components/SchoolStatistics';
import SchoolSiteInfo from './components/SchoolSiteInfo';
import './styles/SchoolPage.css'; // We'll create this file


function MainBlock() {
    const { schoolName } = useParams();
    const { t } = useTranslation('sateliteSchools');
    
    let [loading, setLoading] = useState(true);
    
    const NEWSLETTERS = useSelector(state => state.satelliteSchools.schools_newsletters);
    const schoolBrochures = NEWSLETTERS[schoolName];

    const sortYearsDesc = (a, b) => {
        const academicYearPattern = /^\d{4}-\d{4}$/;

        if (academicYearPattern.test(a) && academicYearPattern.test(b)) {
            return Number(b.slice(0, 4)) - Number(a.slice(0, 4));
        }

        return b.localeCompare(a);
    };

    const galleryYears = Object.keys(SATELLITE_GALLERY_YEARS)
        .filter((year) => (SATELLITE_GALLERY_YEARS[year]?.[schoolName] || []).length > 0)
        .sort(sortYearsDesc);

    const defaultGalleryYear = galleryYears[0] || null;

    const school = useSelector((state) =>
        state.satelliteSchools.schools_list.find((s) => s.name === schoolName)
    );

    const aboutHtml = t(`${schoolName} about`);
    const isAcademy = schoolName === 'academy';

    if (isAcademy) {
        const academyFeatures = [
            t('academy feature 1'),
            t('academy feature 2'),
            t('academy feature 3'),
            t('academy feature 4'),
            t('academy feature 5'),
        ];

        return (
            <>
                <Row className="align-items-center mb-4 academy-page-header">
                    <Col className='text-center d-flex flex-column align-items-center gap-3'>
                        <h1 className="display-5 m-0 fw-bold schoolNameTextColor">
                            <Trans ns="sateliteSchools" i18nKey="academy page title" />
                        </h1>

                        <Button as="a" href={school.registerLink} target="_blank" rel="noopener" variant="primary" size="lg" className='btn-register-form'>
                            <Trans i18nKey="Register Button" />
                        </Button>
                    </Col>
                </Row>

                <Row className="g-4 academy-page-grid">
                    <Col xs={12}>
                        <Card className="academy-page-hero border-0 shadow-sm overflow-hidden">
                            <Row className="g-0 align-items-stretch">
                                <Col xs={12} md={4} className="academy-page-logo-col">
                                    <div className="academy-page-logo-wrap h-100 d-flex align-items-center justify-content-center">
                                        <img
                                            src={school.schoolPhoto}
                                            alt="St Mary’s Online Academy"
                                            className="academy-page-logo"
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} md={8}>
                                    <Card.Body className="academy-page-hero-body">
                                        <div className="academy-page-meta-grid">
                                            <div className="academy-page-meta-item">
                                                <div className="academy-page-meta-label"><Trans ns="sateliteSchools" i18nKey="academy age label" /></div>
                                                <div className="academy-page-meta-value"><Trans ns="sateliteSchools" i18nKey="academy age" /></div>
                                            </div>
                                            <div className="academy-page-meta-item">
                                                <div className="academy-page-meta-label"><Trans ns="sateliteSchools" i18nKey="academy location label" /></div>
                                                <div className="academy-page-meta-value" dangerouslySetInnerHTML={{ __html: t('academy location') }} />
                                            </div>
                                            <div className="academy-page-meta-item">
                                                <div className="academy-page-meta-label"><Trans ns="sateliteSchools" i18nKey="academy format label" /></div>
                                                <div className="academy-page-meta-value"><Trans ns="sateliteSchools" i18nKey="academy format" /></div>
                                            </div>
                                            <div className="academy-page-meta-item">
                                                <div className="academy-page-meta-label"><Trans ns="sateliteSchools" i18nKey="academy live hours label" /></div>
                                                <div className="academy-page-meta-value" dangerouslySetInnerHTML={{ __html: t('academy live hours') }} />
                                            </div>
                                            <div className="academy-page-meta-item academy-page-meta-item-full">
                                                <div className="academy-page-meta-label"><Trans ns="sateliteSchools" i18nKey="academy email label" /></div>
                                                <div className="academy-page-meta-value"><Trans ns="sateliteSchools" i18nKey="academy email" /></div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Col>
                            </Row>
                        </Card>
                    </Col>

                    <Col xs={12} lg={7}>
                        <Card className="academy-content-card h-100 border-0 shadow-sm">
                            <Card.Body className="academy-content-body">
                                <h2 className="academy-section-title mb-3"><Trans ns="sateliteSchools" i18nKey="academy about heading" /></h2>
                                <div className="satellite-about-content academy-about-content" dangerouslySetInnerHTML={{ __html: aboutHtml }} />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xs={12} lg={5}>
                        <Card className="academy-content-card h-100 border-0 shadow-sm">
                            <Card.Body className="academy-content-body">
                                <h2 className="academy-section-title mb-3"><Trans ns="sateliteSchools" i18nKey="academy key features heading" /></h2>
                                <ListGroup variant="flush" className="academy-feature-list">
                                    {academyFeatures.map((feature) => (
                                        <ListGroup.Item key={feature} className="academy-feature-list-item">
                                            {feature}
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>

                                <div className="academy-official-site mt-4">
                                    <p className="mb-2"><Trans ns="sateliteSchools" i18nKey="academy official site" /></p>
                                    <a href={t('academy official site url')} target="_blank" rel="noopener noreferrer">
                                        {t('academy official site url')}
                                    </a>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </>
        );
    }

    return (
        <>
        
            <Row className="align-items-center mb-4 ">
                <Col className='text-center d-flex flex-row justify-content-center align-items-center gap-3' >
                    <h1 className="display-5 m-0 fw-bold schoolNameTextColor">
                        <Trans ns="sateliteSchools" i18nKey={`${schoolName}`} />
                    </h1>
                
                
                    <Button as="a" href={school.registerLink} target="_blank" rel="noopener" variant="primary" size="lg" className='btn-register-form'>
                        <Trans i18nKey="Register Button" />
                    </Button>
                </Col>
            </Row>
            
            <Row>
                <article className="card d-flex flex-column w-100 border-0 rounded-4 overflow-hidden p-0">
                    <div className="row g-0 align-items-center justify-content-center">
                        {/* School Photo */}
                        <div className="col-12 col-md-7">
                            <img
                                src={school.schoolPhoto}
                                alt={`${schoolName} school`}
                                className="school-photo w-100"
                            />
                        </div>
                        
                        {/* School Information Section with Statistics below */}
                        <div className="col-10 col-md-5 d-flex flex-column">
                            <div className="school-info-container">
                                <SchoolSiteInfo schoolName={schoolName} />
                            </div>
                            
                            {/* Statistics moved inside this column for desktop */}
                            <div className="col-12 statistics-row-wrapper d-none d-md-block">
                                <SchoolStatistics schoolName={schoolName} />
                            </div>
                        </div>
                    </div>
                    
                    {/* Statistics Row for mobile - Only visible on smaller screens */}
                    <div className="row g-0 align-items-center d-md-none">
                        <div className="col-12 statistics-row-wrapper">
                            <SchoolStatistics schoolName={schoolName} />
                        </div>
                    </div>
                </article>
            </Row>


                <Row>
                    <Col>
                        <h2 className="justify-content-center d-flex mt-3"><Trans i18nKey="about us" /></h2>
                        <div
                            className="satellite-about-content"
                            dangerouslySetInnerHTML={{ __html: aboutHtml }}
                        />
                        
                    </Col>

                    <h2 className="justify-content-center d-flex mt-5"><Trans i18nKey="Gallery" /></h2>
                    <div style={{ marginTop: "25px" }}>

                        {!galleryYears.length ? (
                            <Alert variant="secondary" className="mb-0">
                                Gallery images will be added soon.
                            </Alert>
                        ) : (

                        <Tab.Container id="left-tabs-example" defaultActiveKey={defaultGalleryYear}>
                            <Row className="justify-content-center d-flex">
                                <Col sm={3}>
                                    <Nav variant="pills" className="flex-column">
                                        {galleryYears.map((year) => (
                                            <Nav.Item key={year}>
                                                <Nav.Link eventKey={year} onClick={() => setLoading(true)}>{year}</Nav.Link>
                                            </Nav.Item>
                                        ))}
                                    </Nav>
                                </Col>
                            </Row>

                            <Row className="justify-content-center d-flex">
                                <Col sm={9}>
                                    <Tab.Content>
                                        {galleryYears.map((year) => (
                                            <Tab.Pane eventKey={year} key={year}>
                                                <div className="pta-gallery">
                                                    {generateImageTabs(SATELLITE_GALLERY_YEARS[year][schoolName], loading, setLoading, "right")}
                                                </div>
                                            </Tab.Pane>
                                        ))}
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>

                        )}

                    </div>
                    { schoolBrochures ?
                    <NewsLetterAccordion schoolBrochures={schoolBrochures} /> 
                    : "" } 
                </Row>
                
        </>
    )
}

export default MainBlockLayout(MainBlock);